
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./Login.css";

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() =>{
    const token = localStorage.getItem('authToken')
    if(token !== null)
    {
      window.location = '/dashboard'
    }
  })

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    const apiBaseUrl = process.env.REACT_APP_ENV === 'local'
      ? (process.env.REACT_APP_BACKEND_USER_API_LOCAL || 'http://localhost:3001')
      : (process.env.REACT_APP_BACKEND_USER_API || 'https://api.users.dharmiq.co.in');
    const loginUrl = `${apiBaseUrl}/api/adminuser/user-login`;
    console.log(loginUrl);
    
    try {
      const response = await fetch(loginUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }
      console.log(data?.data);
      

      if (data?.data?.token) {
        localStorage.setItem('authToken', data?.data?.token);
        localStorage.setItem('_id', data?.data?._id);
        localStorage.setItem('email', data?.data?.email);
        localStorage.setItem('menu_permissions', JSON.stringify(data?.data?.menu_permissions));
        localStorage.setItem('permissions', JSON.stringify(data?.data?.permissions));
      }

      // Redirect after successful login, or update app state as needed
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.message || 'Unable to login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="login-wrapper">
      <Row className="login-row">

        <Col lg={7} className="hero-section">
          <div className="hero-content">
            <span className="badge-custom">
              Subscription Platform
            </span>

            <h1>
              Manage Payments,
              <br />
              Subscriptions &
              <br />
              Customers
            </h1>

            <p>
              Secure dashboard for managing Razorpay,
              PayU, plans, mandates and customer
              subscriptions.
            </p>
          </div>
        </Col>

        <Col lg={5} className="form-section">
          <div className="login-card">

            <h2>Welcome Back</h2>

            <p className="subtitle">
              Sign in to continue
            </p>

            <Form onSubmit={handleSubmit}>

              <Form.Group className="mb-4">
                <Form.Label>Email</Form.Label>

                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Password</Form.Label>

                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                />
              </Form.Group>

              {error && (
                <div className="text-danger mb-3">{error}</div>
              )}

             {/*  <div className="d-flex justify-content-between mb-4">
                <Form.Check
                  type="checkbox"
                  label="Remember me"
                />

                <a href="/">
                  Forgot Password?
                </a>
              </div> */}

              <Button className="login-btn" type="submit" disabled={loading}>
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>

            </Form>

          </div>
        </Col>

      </Row>
    </Container>
  );
}

